import type {
    AdLocation,
    FilteredItemsPageUrlQueryParams,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import {LocalStorage} from '@frontend/services/LocalStorage'
import {useAdsStore} from '@frontend/stores'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Возвращает обработчик применения выбора локации в панели поиска.
export function useItemsSearchLocationSelectedHandler(): (newLocation: AdLocation) => void {
    const setLocation = useAdsStore(
        state => state.setSearchPanelLocation
    )
    const makeItemsListUrl = useAdsStore(
        state => state.makeItemsListUrl
    )
    // Данные о текущем URL.
    const {
        urlQueryParams,
        urlQueryData,
    } = useUrlQueryParams<FilteredItemsPageUrlQueryParams>()
    // Нажатие кнопки "Найти" для ключевых слов.
    return useEventCallback((newLocation: AdLocation): void => {
        LocalStorage.setFilterLocation(newLocation.slugWithId)
        setLocation(newLocation.id === 0 ? null : newLocation)
        // Собираем URL query для перехода на страницу объявлений или услуг.
        const queryParams: Partial<FilteredItemsPageUrlQueryParams> = urlQueryParams.has('location')
            ? urlQueryData
            : {}
        delete queryParams.location
        // Переходим на страницу объявлений.
        NavigationService.navigate(makeItemsListUrl(queryParams))
    })
}
